(() => {
  const sections = document.querySelectorAll('[data-mm-reassurance]');

  sections.forEach((section) => {
    const viewport = section.querySelector('[data-mm-reassurance-viewport]');
    const track = section.querySelector('[data-mm-reassurance-track]');
    const items = [...section.querySelectorAll('[data-mm-reassurance-item]')];
    const dots = [...section.querySelectorAll('[data-mm-reassurance-dot]')];

    if (!viewport || !track || items.length < 2 || dots.length !== items.length) return;

    const setActive = (index, shouldScroll = false) => {
      const activeIndex = Math.max(0, Math.min(index, items.length - 1));
      items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === activeIndex));
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', String(isActive));
      });

      if (shouldScroll) {
        // `behavior: 'smooth'` demande en JS l'emporte sur `scroll-behavior` du CSS :
        // la preference systeme se lit donc ici, sinon la media query ne sert a rien.
        const reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        items[activeIndex].scrollIntoView({ behavior: reduit ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      }
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => setActive(Number(dot.dataset.mmReassuranceDot), true));
    });

    let scrollTimer;
    viewport.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => {
        const viewportCenter = viewport.getBoundingClientRect().left + viewport.offsetWidth / 2;
        let closestIndex = 0;
        let closestDistance = Infinity;

        items.forEach((item, index) => {
          const itemCenter = item.getBoundingClientRect().left + item.offsetWidth / 2;
          const distance = Math.abs(viewportCenter - itemCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        setActive(closestIndex);
      }, 80);
    }, { passive: true });
  });
})();
